<template>
<div class="container">
<div  id="login-overlay" class="modal-dialog" style="max-width:500px;">
      <div class="modal-content" v-if="authenticatedComp">
            <div class="modal-header">
                <h3 v-if="userRoleComp=='Sitter'" class="text-center modal-title"> You are logged in as a Sitter</h3>
                <h3 v-if="userRoleComp=='Client'" class="text-center modal-title"> You are logged in as a Customer</h3>
            </div>
            <div class="text-center">
            <a class="text-center" href="javascript:;" @click="goAccount()">Go to account to switch role</a>
            <a href="" @click="goBack()"><h3 class="text-center">Back</h3></a>
            </div>
      </div>
      <div class="modal-content" v-if="!authenticatedComp">
          <div class="modal-header text-center" style="padding-top:0px !important;padding-bottom:0px !important;">
              <h3 style="margin-bottom:0px;">The next level of dog boarding</h3>
              <h3 v-if="switchAccountComp" class=" alert alert-info">Please login again to complete switching your account</h3>
          </div>
      
    
          <div class="modal-body" >
              <div class="row">
                  <div class="col-xs-12 col-sm-12" >
                      <div class="alert alert-danger alert-dismissible" v-if="error">
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                   </button>
                <p>{{error}}</p>
            </div>

            <div class="alert alert-success alert-dismissible" v-if="notification">
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                   </button>
                <strong></strong>{{notification}}
            </div>
                      <div class="well" style="margin-bottom:5px;">
                          <div>
                              <div class="form-group ">
                                  <label for="username" class="control-label">Email</label>
                                  <div class="inner-addon right-addon">
                                  <i v-show="errors.has('email')" class="fa fa-warning"></i>
                                  <i v-show="!errors.has('email')" v-if="credentials.username" class="fa fa-paw text-success "></i>
                                  <input type="email" name="email" v-validate="'required|email'" :class="{'input': true, 'has-error': errors.has('email') }" class="form-control" v-model.lazy="credentials.username" @keyup.enter="validateBeforeSubmit()" placeholder="Email address">
                                  </div>
                                  <span v-show="errors.has('email')" class="help-inline text-danger h5">{{ errors.first('email') }}</span>
                                  
                              </div>
                              <div class="form-group">
                                 <label for="password" class="control-label">Password</label>
                              <div class="inner-addon right-addon">
                                  <i v-show="errors.has('password')" class="fa fa-warning"></i>
                                  <i v-show="!errors.has('password')" v-if="credentials.password" class="fa fa-paw text-success "></i>
                                 <input type="password" name="password" class="form-control" v-validate="'required|min:6'" :class="{'input': true, 'has-error': errors.has('password') }" v-model="credentials.password" @keyup.enter="validateBeforeSubmit()" placeholder="Password" data-vv-delay="1500">
                                 </div>
                                  <span v-show="errors.has('password')" class="text-danger h5">{{ errors.first('password') }}</span>
                              </div>
                                
                              <button v-bind:disabled="filledRequired==false" @click="validateBeforeSubmit()" class="btn btn-success btn-block btn-title">Login</button>
                          </div>
                        </div>
                  </div>
                  
                  <div class="col-xs-12 col-sm-12">
                     
                      <ul class="list-unstyled" style="line-height: 2;">
                          
                          <li> <a style="background-color: #4267b2;color: #fff; margin: 20px auto 0px auto" class="btn btn-lg btn-title btn-block btn-social btn-facebook">
                          <span class="fa fa-facebook"></span>
                          <fb-signin-button class="text-center"
                              :params="fbSignInParams"
                              @success="onSignInSuccess"
                              @error="onSignInError">
                              Continue with Facebook Account
                            </fb-signin-button></a> </li>
                          
                      </ul>
                      
                      <button @click="goSignup()" class="btn btn-default btn-block btn-title">Register with your Email</button>
                      
                     
                  </div>
                  
               
              </div>
                  <br>
                  
                  <a class="card-link" style="padding-left: 5px; font-size:14px;" href="javascript:;" @click="forgotPassword()">Forgot Password?</a>
                  <hr style="margin-bottom:5px;">
                  <p style="padding-left:5px;" class="small">By registering you agree to our <a href="/terms-and-conditions">terms and conditions</a></p> 
              
          </div>
      </div>

  
  </div>
    </div>
</template>



<script>
  
  import auth from '../../auth/index'
  import store from '../../data/store'
  import Alert from '../SharedComponents/Alert.vue'
  import PasswordReset from './PasswordReset.vue'

  export default {
    name: 'login',
    data() {
      return {  
        fbSignInParams: {
           scope: 'email,public_profile',
           return_scopes: true,
          
        },
        scrollPosition:'',
        credentials: {
          username: '',
          password: '',

        },
        FBTokenInfo: {
          Token: '',
          Email: '',
          Provider: 'Facebook',
          FirstName: '',
          LastName: '',
          UserRole: '',
          CountryId: '',
          ProfilePicUrl: ''

        },
        notification:'',
        error: '',
        alert: false,
        alertMsg: '',

      }
    },
    updated(){
    var self = this
    // $('input').focus(function (){
    //         self.scrollPosition = window.scrollY
            
    // })
    // $('input').blur(function (){
    //         // $(window).animate({ scrollTop: this.scrollPosition }, "slow");
    //         self.$SmoothScroll(self.scrollPosition, 350)
            
    // })

    
    // $zopim(function() {
    //      $zopim.livechat.badge.hide();
    // });
    
    


  },
  
    methods: {
      goSignup(){
         this.$router.push({ path: '/signup'})
      },
      goBack(){
        this.$router.push({path: '/'})
      },
      goAccount(){
        this.$router.push({path: '/account'})
      },
      validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // eslint-disable-next-line
          this.submit()
          return;
        }

        swal("Something is missing", "Please complete all the required fields to continue.", "info")
      });
    },
      submit() {
        $(window).scrollTop(0)
        // var credentials = "grant_type=password&username=" + this.credentials.username + "&password=" + this.credentials.password;
         var loginCreds = {
            grant_type: "password",
            username: this.credentials.username,
            password: this.credentials.password,
        }
        localStorage.setItem('email', this.credentials.username)
        store.commit('email', localStorage.getItem('email'))
        
        if (this.$route.query.redirect != null) {
          auth.login(this, loginCreds, this.$route.query.redirect)
        }
        else if (this.$route.query.sitter!=null)
        {
          var redirectBack = "sitter/" + this.$route.query.sitter
          auth.login(this, loginCreds, redirectBack)
        } else {
          auth.login(this, loginCreds)
        }
     
        
      },
      forgotPassword(){
          if (this.credentials.username!=null){
            localStorage.setItem('email', this.credentials.username)
            store.commit('email', localStorage.getItem('email'))
            }
          this.$router.push({path: '/passwordreset'})
       
      },
      onSignInSuccess (response) {
         var self = this
         self.error = ''
         self.FBTokenInfo.ProfilePicUrl = "images/sitterProfilePic.png"
        //  FB.api('/me/picture?type=large', function(response){
        //     if (response.data!=null && response.data.is_silhouette !=null && response.data.is_silhouette==false ){
        //         self.FBTokenInfo.ProfilePicUrl = response.data.url
        //     } else
        //     {
              
        //     }
        //     });
         FB.api('/me', {fields: 'first_name,last_name,email'}, function(response) {  
            self.FBTokenInfo.FirstName = response.first_name
            self.FBTokenInfo.LastName = response.last_name
            self.FBTokenInfo.Email = response.email,
            self.FBTokenInfo.CountryId = localStorage.getItem('CountryId')
            localStorage.setItem('email', response.email)
            store.commit('email', localStorage.getItem('email'))
            self.notification = 'Logging in through Facebook'
            FB.getLoginStatus(function(response) {
              self.FBTokenInfo.Token = response.authResponse.accessToken
              if (self.$route.query.redirect) {
                  auth.fbLogin(self, self.FBTokenInfo, self.$router, self.$route.query.redirect)
              }
              else if (self.$route.query.sitter){
                 var redirectBack = "sitter/" + self.$route.query.sitter
                 auth.fbLogin(self, self.FBTokenInfo, redirectBack)
              } else {
                auth.fbLogin(self, self.FBTokenInfo)
              }
              }); 
          });
          
         
       },
      onSignInError (error) {
          self.notification = ''
          this.error = "Sorry but Facebook login failed"
      },
      SignOut(response){
        FB.logout(function(response){
          
        })
      }
    },
    computed: {
      switchAccountComp: function(){
        if (this.$route.query.switch=="yes")
          return true
        else 
          return false
      },
      alertData: function () {
        if (this.$route.query.redirect) {
          this.alertMsg = "Hello sir please sign in"
          this.alert = true
        } else {
          this.alert = false

        }
        return this.alertMsg
      },
      filledRequired: function () {
        if (this.credentials.username == '' || this.credentials.password == '') {
          return false;
        } else {
          return true
        }
      },
      authenticatedComp: function(){
        return store.getters.authenticated
      },
      userRoleComp: function(){
        return store.getters.userRole
      }                
      
    },


    components: {
      Alert,
      PasswordReset
    }
  }

</script>


<style scoped>


label{
  font-family: 'Yanone Kaffeesatz', sans-serif;
  font-size: large;
  color:#817f7f;
}

.lead {
  font-family: 'Yanone Kaffeesatz', sans-serif;

    word-spacing: 00.19em;
    font-size: 2.55em;
}

 .fb-signin-button {
  /* This is where you control how the button looks. Be creative! */
 
 display: inline-block;
 
}


</style>


// WEBPACK FOOTER //
// Login.vue?08476400